module.exports = __webpack_public_path__ + "08073e2f30afe2e41ea9aeee351ef029.svg";